<div class='SelectRoleWizardStep p-3'>
  <form [formGroup]='formGroup'>
    <mat-radio-group
      aria-label='Select an role'
      class='d-flex flex-row flex-sm-column'
      formControlName='role'>
      <mat-radio-button [value]='roles.SINGLE_USER'
      >User
      </mat-radio-button
      >
      <mat-radio-button [value]='roles.MANAGER' class='mt-0 mt-sm-3 ms-3 ms-sm-0'
      >Manager
      </mat-radio-button
      >
      <mat-radio-button [value]='roles.PARTNER' class='mt-0 mt-sm-3 ms-3 ms-sm-0'
      >Partner
      </mat-radio-button
      >
      <mat-radio-button [value]='roles.FRANCHISE' class='mt-0 mt-sm-3 ms-3 ms-sm-0'
      >Franchisee
      </mat-radio-button
      >
    </mat-radio-group>
  </form>
</div>